import React, { forwardRef } from "react";
const SvgStoryRingRead = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 66.1818 66.1818", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 33.0909, cy: 33.0909, r: 31.8409, stroke: "#BFBFBF", strokeWidth: 2.5 }));
const ForwardRef = forwardRef(SvgStoryRingRead);
export default ForwardRef;
